/**
 * Utilidad para actualizar dinámicamente el favicon de la aplicación
 */

export function updateFavicon(logoUrl, baseUrl = '') {
  if (!logoUrl) {
    console.warn('No logo URL provided for favicon update');
    return;
  }

  // Construir URL completa si es necesaria
  const fullLogoUrl = logoUrl.startsWith('http') ? logoUrl : baseUrl + logoUrl;

  try {
    // Buscar o crear el elemento link para el favicon
    let faviconLink = document.querySelector('link[rel="icon"]');
    
    if (!faviconLink) {
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      document.head.appendChild(faviconLink);
    }

    // Actualizar el href del favicon
    faviconLink.href = fullLogoUrl;

    // Si es una imagen PNG o SVG, también actualizar el atributo type
    if (fullLogoUrl.endsWith('.png')) {
      faviconLink.type = 'image/png';
    } else if (fullLogoUrl.endsWith('.svg')) {
      faviconLink.type = 'image/svg+xml';
    } else if (fullLogoUrl.endsWith('.ico')) {
      faviconLink.type = 'image/x-icon';
    }

    console.log('Favicon actualizado:', fullLogoUrl);
  } catch (error) {
    console.error('Error al actualizar favicon:', error);
  }
}
